import React, { FC, useEffect, useState, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { getSpotPermissions } from 'lib/spot-permissions';
import { getPermissions } from 'lib/permissions';
import { useSpots } from 'lib/spots';
import QRCode from 'qrcode';
import { PDFDownloadLink } from '@react-pdf/renderer';

import { UserPage } from 'components/UserPage';
import { Section } from 'components/Section';
import { QRDocument } from 'components/Map/QRDocument';
import { BreadCrumbs } from "components/BreadCrumbs";


const DownloadButton: FC = () => (
    <div className="download-button">
        印刷用PDFを保存

        <style jsx>{`
            margin-top: 10px;
            padding: 14px 28px 14px 28px;
            width: 70%;
            max-width: 311px;
            border-radius: 100vh;
            background-color: rgb(254, 129, 37);
            color: #ffffff;
            font-size: 14px;
            text-align: center;
            text-decoration: none;
            cursor: pointer;
            margin: auto;
        `}</style>
    </div>
);


type Props = {};

export const SpotQrPage: FC<Props> = (props) => {
    // @ts-ignore
    const id = props.match.params.id;
    const [spot, setSpot] = useState<Spot | null>(null);
    const [dataUri, setDataUri] = useState('');
    const [initialized, setInitialized] = useState(false);
    const { get } = useSpots();
    const card = useRef<HTMLDivElement>(null);
    const history = useHistory();

    useEffect(() => {
        async function initialize() {
            const spotPermissions = await getSpotPermissions(id);
            const userPermission = await getPermissions();
            if (!spotPermissions.view) {
                if (userPermission.status === 'unpaid') {
                    history.push(
                        `/map/spot/${id}`,
                        {
                            flash: 'サービスをご利用になるには未払い金をお支払いください。',
                            error: true,
                        },
                    );
                }
                return;
            }

            const spot = await get(Number(id));
            setSpot(spot);

            try {
                const content = `${window.location.origin}/map/spot/${id}?checkin=1`;
                const dataUri = await QRCode.toDataURL(content, {
                    margin: 1,
                });
                setDataUri(dataUri);
            } catch (e) {
                // TODO:
            }
            setInitialized(true);
        }
        initialize();
    }, []);

    return (
        <UserPage title="Salon.jp | QRコード" disableBackButton>
            <Section fillOnSp={true}>
                <div className="wrap">
                    <div className="head">
                        <h1 className="title">スタンプ用QRコード</h1>
                    </div>
                    <p className="introduction">
                        こちらのQRコードをお店に設置し、<br />
                        訪れたサロンメンバーさんがスタンプを貯められるようにしましょう！
                    </p>

                    <div ref={card} className="qr-card">
                        <img src="/img/map_admin/qr-hat.png" alt="" />
                        <p className="name">{spot?.name}</p>
                        <div className="qr-wrapper">
                            <div className="qr-frame top-left"></div>
                            <div className="qr-frame top-right"></div>
                            <div className="qr-frame bottom-left"></div>
                            <div className="qr-frame bottom-right"></div>
                            {dataUri
                                ? <img className="qr" src={dataUri} alt="" />
                                : <img className="qr" src="/img/map_admin/ph-white.png" alt="" />
                            }
                        </div>
                        <p className="caption">こちらのバーコードを読み込んでください</p>
                    </div>

                    <div className="actions">
                        {initialized && (
                            spot && dataUri && (
                                <PDFDownloadLink
                                    style={{ textDecoration: "none" }}
                                    document={<QRDocument spotName={spot.name} qrDataUri={dataUri} />}
                                >
                                    {() => <DownloadButton />}
                                </PDFDownloadLink>
                            )
                        )}
                    </div>
                </div>
            </Section>

            <style jsx>{`
                .bread-crumbs-wrapper {
                    padding-top: 10px;
                    padding-bottom: 20px;
                }
                .wrap {
                    min-height: 50vh;
                    padding: 1rem;
                    padding-top: 0px;
                }
                .head > .title {
                    margin-top: 0;
                    font-size: 1.5rem;
                }
                .introduction {
                    padding-bottom: 2rem;
                    font-size: 0.8rem;
                    color: #2b2b2b;
                }
                .qr-card {
                    margin: 0 auto;
                    padding: 1.5rem 1.5rem 4rem;
                    width: 311px;
                    height: 401px;
                    border: 1px solid #ccc;
                    text-align: center;
                }
                .qr-card > p {
                    margin: 0;
                }
                .qr-card > .name {
                    padding: 1rem 0 2rem;
                    font-size: 1.3rem;
                    font-weight: bold;
                    color: rgb(254, 129, 37);
                }
                .qr-card > .caption {
                    font-size: 0.7rem;
                    color: #a8a8a8;
                }
                .qr-wrapper {
                    width: 170px;
                    height: 170px;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: auto;
                    margin-bottom: 15px;
                }
                .qr-frame {
                    position: absolute;
                    width: 30px;
                    height: 30px;
                }
                .qr-frame.top-left {
                    top: 0;
                    left: 0;
                    border-top: 2px solid rgb(254, 129, 37);
                    border-left: 2px solid rgb(254, 129, 37);
                }
                .qr-frame.top-right {
                    top: 0;
                    right: 0;
                    border-top: 2px solid rgb(254, 129, 37);
                    border-right: 2px solid rgb(254, 129, 37);
                }
                .qr-frame.bottom-left {
                    bottom: 0;
                    left: 0;
                    border-bottom: 2px solid rgb(254, 129, 37);
                    border-left: 2px solid rgb(254, 129, 37);
                }
                .qr-frame.bottom-right {
                    bottom: 0;
                    right: 0;
                    border-bottom: 2px solid rgb(254, 129, 37);
                    border-right: 2px solid rgb(254, 129, 37);
                }
                .qr {
                    width: 150px;
                    height: 150px;
                }
                .actions {
                    margin: 2rem 0 1rem;
                    text-align: center;
                    padding-top: 10px;
                }
                @media screen and (max-width: 540px) {
                    .wrap {
                        min-height: 100vh;
                        padding: 2rem;
                    }
                }
            `}</style>
        </UserPage>
    );
};
